module.exports = __webpack_public_path__ + "img/Istrazivanjestavovazaposlenih.4130499d.jpg";